/**
 * Os dois campos de uma mensagem pronta: título e texto.
 *
 * Uma cópia só para criar e para corrigir, nas Configurações e na caixa da
 * conversa. Antes eram duas, e a da correção já tinha perdido a ajuda e os
 * exemplos que a de criar mostrava.
 *
 * ── A ajuda do texto pede para não pôr dado de cliente ───────────────────
 *
 * A lista é lida pela organização inteira, sem carteira, e um pedido de
 * eliminação do titular não a alcança (`apps/api/src/titular/alcance.ts`).
 * Desde que ela nasce também na caixa da conversa, com o cliente na tela,
 * reaproveitar uma resposta com o nome e a placa dele é o gesto natural. A
 * frase é a proteção, como no diálogo de feedback.
 */

import type { ReactNode } from 'react';
import { Campo, CampoArea } from '@/shared/ui';
import { TEXTO_MAXIMO, TITULO_MAXIMO, type RascunhoDeMensagemPronta } from '../model/rascunho';

export function CamposDaMensagemPronta({
  rascunho,
  aoMudar,
  focar = false,
}: {
  rascunho: RascunhoDeMensagemPronta;
  aoMudar: (rascunho: RascunhoDeMensagemPronta) => void;
  /** Põe o cursor no título ao aparecer: quando os campos abrem por um clique. */
  focar?: boolean;
}): ReactNode {
  return (
    <>
      <Campo
        rotulo="Título"
        type="text"
        value={rascunho.titulo}
        maxLength={TITULO_MAXIMO}
        autoFocus={focar}
        placeholder="Saudação"
        ajuda="É por ele que a equipe encontra o texto. Não use nome, telefone ou placa de cliente."
        onChange={(evento) => aoMudar({ ...rascunho, titulo: evento.currentTarget.value })}
      />
      <CampoArea
        rotulo="Texto"
        rows={3}
        value={rascunho.texto}
        maxLength={TEXTO_MAXIMO}
        placeholder="Bom dia! Sou da Cliqfy. Em que posso ajudar?"
        ajuda="Vale para toda a organização. Não inclua nome, telefone, placa, endereço ou documento de cliente."
        onChange={(evento) => aoMudar({ ...rascunho, texto: evento.currentTarget.value })}
      />
    </>
  );
}
